module.exports = __webpack_public_path__ + "static/media/fleet.bcbc001e.jpg";